import { render, staticRenderFns } from "./UploadOptionsTXT.vue?vue&type=template&id=8c346856&"
import script from "./UploadOptionsTXT.vue?vue&type=script&lang=js&"
export * from "./UploadOptionsTXT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports